(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('logger', logger);

    function logger($log, $translate) {
        var service = {
            error: error,
            info: info,
            success: success,
            warning: warning,
            toExceptionless: toExceptionless,
            log: $log.log
        };

        return service;

        function toExceptionless(message, data, title, level) {
            try {
                exceptionless.ExceptionlessClient.default.createLog("SkillUI.logger", message, level)
                    .setProperty("data", data)
                    .setProperty("title", title)
                    .submit();
            }
            catch (err) {
                var noop = 1;
            }
        }
        
        function error(message, data, title) {
            message = $translate.instant(message);
            title = (title === undefined) ? undefined : $translate.instant(title);

            toastr.error(message, title);

            toExceptionless(message, data, title, 'error');

            $log.error('Error: ' + message, data);
        }

        function info(message, data, title) {
            message = $translate.instant(message);
            title = (title === undefined) ? undefined : $translate.instant(title);

            toastr.info(message, title);

            toExceptionless(message, data, title, 'info');

            $log.info('Info: ' + message, data);
        }

        function success(message, data, title) {
            message = $translate.instant(message);
            title = (title === undefined) ? undefined : $translate.instant(title);

            toastr.success(message, title);

            toExceptionless(message, data, title, 'trace');

            $log.info('Success: ' + message, data);
        }

        function warning(message, data, title) {
            message = $translate.instant(message);
            title = (title === undefined) ? undefined : $translate.instant(title);

            toastr.warning(message, title);

            toExceptionless(message, data, title, 'warning');

            $log.warn('Warning: ' + message, data);
        }
    }
}());